import Authenticator from 'components/economic-concret/authenticator';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Dropdown, Form, InputGroup, Modal, Row, Table } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import ErrorMessage from '../../components/errorMessage';
import SuccessMessage from '../../components/successMessage';
import Loading from 'components/economic-concret/components/loading';
import api from '../../api/api';

export default function AllMaterials() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [registeredMaterials, setRegisteredMaterials] = useState([]);
  const [materialsType, setMaterialsType] = useState([]);
  const [sieves, setSieves] = useState([]);
  const [diameters, setDiameters] = useState([]);

  const [materialId, setMaterialId] = useState('');
  const [name, setName] = useState('');
  const [type, setType] = useState('');
  const [unitMass, setUnitMass] = useState('');
  const [specificMass, setSpecificMass] = useState('');
  const [unitCost, setUnitCost] = useState('');
  const [cValue, setCValue] = useState('');
  const [resistence, setResistence] = useState('');
  const [saturationPercentage, setSaturationPercentage] = useState('');
  const [code, setCode] = useState('');
  const [description, setDescription] = useState('');
  const [aggregateRetainedFractions, setAggregateRetainedFractions] = useState([]);
  const [sieveToSave, setSieveToSave] = useState('');
  const [sieveValueToSave, setSieveValueToSave] = useState('');
  const [cementDiameterRetainedFractions, setCementDiameterRetainedFractions] = useState([]);
  const [cementDiameterToSave, setCementDiameterToSave] = useState('');
  const [cementDiameterValueToSave, setCementDiameterValueToSave] = useState('');

  const [showModalToSaveAggregates, setShowModalToSaveAggregates] = useState(false);
  const [showModalToSaveCement, setShowModalToSaveCement] = useState(false);
  const [showModalToSaveAdditive, setShowModalToSaveAdditive] = useState(false);
  const [showModalToSaveWater, setShowModalToSaveWater] = useState(false);

  const [isWaterReducingAdditive, setIsWaterReducingAdditive] = useState(false);

  const [suppliers, setSuppliers] = useState([]);
  const [supplierToAdd, setSupplierId] = useState('');

  function sanitizeNumericInput(value) {
    return value.replace(/[^0-9.,]/g, '');
  }

  useEffect(() => {
    getRegisteredMaterials();
  }, []);

  function getRegisteredMaterials() {
    setLoading(true);
    api
      .get('/materials/registered', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setRegisteredMaterials(returnFromApi.data);
        setLoading(false);
      })
      .catch((returnFromApi) => {
        setLoading(false);
        setShowErrorMessage(true);
        setErrorMessage(returnFromApi.response.data);
        console.error('ops! ocorreu um erro' + returnFromApi.data);
      });
  }

  function getSuppliers() {
    api
      .get('/suppliers', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setSuppliers(returnFromApi.data);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getSieves() {
    setSieves([
      { name: 'Fundo' },
      { name: '0.075' },
      { name: '0.3' },
      { name: '0.6' },
      { name: '0.15' },
      { name: '1.2' },
      { name: '2.4' },
      { name: '4.8' },
      { name: '6.3' },
      { name: '9.5' },
      { name: '12.5' },
      { name: '19.0' },
      { name: '25.0' }
    ]);
  }

  function getDiameters() {
    setDiameters([
      { name: '0.001' },
      { name: '0.0013' },
      { name: '0.0015' },
      { name: '0.0025' },
      { name: '0.0065' },
      { name: '0.0085' },
      { name: '0.01' },
      { name: '0.013' },
      { name: '0.018' },
      { name: '0.02' },
      { name: '0.023' },
      { name: '0.028' },
      { name: '0.032' },
      { name: '0.0375' },
      { name: '0.045' },
      { name: '0.053' },
      { name: '0.063' },
      { name: '0.075' },
      { name: '0.09' },
      { name: '0.1125' },
      { name: '0.125' },
      { name: '0.15' },
      { name: '0.18' },
      { name: '0.225' },
      { name: '0.45' },
      { name: '0.9' },
      { name: '1.8' },
      { name: '3.6' },
      { name: '5.55' },
      { name: '7.9' },
      { name: '11.0' },
      { name: '15.75' },
      { name: '22.0' },
      { name: '28.5' }
    ]);
  }

  function getAggregatesTypes() {
    setMaterialsType([
      { type: 'SAND', descriptionType: 'Areia' },
      { type: 'GRAVEL', descriptionType: 'Brita' }
    ]);
  }

  function openModalToSaveAggregates() {
    setShowModalToSaveAggregates(true);
    getAggregatesTypes();
    getSieves();
    getSuppliers();
  }

  function openModalToSaveCement() {
    setShowModalToSaveCement(true);
    getDiameters();
    getSuppliers();
  }

  function openModalToSaveAdditive(additiveType) {
    if (additiveType === 'WATER_REDUCING_ADDITIVE') {
      setIsWaterReducingAdditive(true);
    } else {
      setIsWaterReducingAdditive(false);
    }

    setShowModalToSaveAdditive(true);
    getDiameters();
    getSuppliers();
  }

  function openModalToSaveWater() {
    setShowModalToSaveWater(true);
    getSuppliers();
  }

  function closeModalToSaveAggregates() {
    setShowModalToSaveAggregates(false);
    cleanFields();
  }

  function closeModalToSaveCement() {
    setShowModalToSaveCement(false);
    cleanFields();
  }

  function closeModalToSaveAdditive() {
    setShowModalToSaveAdditive(false);
    cleanFields();
  }

  function closeModalToSaveWater() {
    setShowModalToSaveWater(false);
    cleanFields();
  }

  function cleanFields() {
    setMaterialId('');
    setName('');
    setType('');
    setUnitMass('');
    setSpecificMass('');
    setCValue('');
    setResistence('');
    setAggregateRetainedFractions([]);
    setCementDiameterRetainedFractions([]);
    setSaturationPercentage('');
    setSupplierId('');
    setCode('');
    setDescription('');
    setUnitCost('');
  }

  function addAggregateRetainedFraction() {
    const fractionToAdd = {
      sieve: sieveToSave,
      value: sieveValueToSave
    };
    let alreadyAdded = false;

    for (const fractionFromList of aggregateRetainedFractions) {
      if (fractionFromList.sieve === sieveToSave) {
        alreadyAdded = true;
      }
    }
    if (alreadyAdded) {
      setErrorMessage('Essa Peneira já foi adicionada');
      setShowErrorMessage(true);
    } else {
      aggregateRetainedFractions.push(fractionToAdd);
    }

    setSieveToSave('');
    setSieveValueToSave('');
  }

  function deleteAggregateRetainedFraction(fraction) {
    const fractionIndex = aggregateRetainedFractions.indexOf(fraction);

    if (fractionIndex > -1) {
      aggregateRetainedFractions.splice(fractionIndex, 1);
    }
  }

  function addCementRetainedFraction() {
    const fractionToAdd = {
      diameter: cementDiameterToSave,
      value: cementDiameterValueToSave
    };
    let alreadyAdded = false;

    for (const fractionFromList of cementDiameterRetainedFractions) {
      if (fractionFromList.diameter === cementDiameterToSave) {
        alreadyAdded = true;
      }
    }
    if (alreadyAdded) {
      setErrorMessage('Esse Diâmetro já foi adicionado');
      setShowErrorMessage(true);
    } else {
      cementDiameterRetainedFractions.push(fractionToAdd);
    }

    setCementDiameterToSave('');
    setCementDiameterValueToSave('');
  }

  function deleteCementRetainedFraction(fraction) {
    const fractionIndex = cementDiameterRetainedFractions.indexOf(fraction);

    if (fractionIndex > -1) {
      cementDiameterRetainedFractions.splice(fractionIndex, 1);
    }
  }

  const saveCement = (event) => {
    event.preventDefault();
    setLoading(true);
    const cement = {
      cementId: materialId,
      name: name,
      retainedFractions: cementDiameterRetainedFractions,
      specificMass: specificMass,
      cValue: cValue,
      resistence: resistence,
      supplierId: supplierToAdd,
      code: code,
      description: description,
      unitCost: unitCost
    };

    if (materialId) {
      api
        .put('/cement', cement, {
          headers: {
            Authorization: sessionStorage.getItem('token')
          }
        })
        .then((returnFromApi) => {
          setSuccessMessage(returnFromApi.data);
          setShowSuccessMessage(true);
          cleanFields();
          getRegisteredMaterials();
          setLoading(false);
        })
        .catch((error) => {
          console.error('ops! ocorreu um erro' + error);
          setShowErrorMessage(true);
          setErrorMessage(error.response.data);
          setLoading(false);
        });
    } else {
      api
        .post('/cement', cement, {
          headers: {
            Authorization: sessionStorage.getItem('token')
          }
        })
        .then((returnFromApi) => {
          setSuccessMessage(returnFromApi.data);
          setShowSuccessMessage(true);
          cleanFields();
          getRegisteredMaterials();
          setLoading(false);
        })
        .catch((error) => {
          console.error('ops! ocorreu um erro' + error);
          setShowErrorMessage(true);
          setErrorMessage(error.response.data);
          setLoading(false);
        });
    }
  };

  const saveAggregate = (event) => {
    event.preventDefault();
    setLoading(true);
    const aggregate = {
      materialId: materialId,
      name: name,
      retainedFractions: aggregateRetainedFractions,
      specificMass: specificMass,
      unitMass: unitMass,
      aggregateType: type,
      supplierId: supplierToAdd,
      code: code,
      description: description,
      unitCost: unitCost
    };

    if (materialId) {
      api
        .put('/aggregate', aggregate, {
          headers: {
            Authorization: sessionStorage.getItem('token')
          }
        })
        .then((returnFromApi) => {
          setSuccessMessage(returnFromApi.data);
          setShowSuccessMessage(true);
          cleanFields();
          getRegisteredMaterials();
          setLoading(false);
        })
        .catch((error) => {
          console.error('ops! ocorreu um erro' + error);
          setShowErrorMessage(true);
          setErrorMessage(error.response.data);
          setLoading(false);
        });
    } else {
      api
        .post('/aggregate', aggregate, {
          headers: {
            Authorization: sessionStorage.getItem('token')
          }
        })
        .then((returnFromApi) => {
          setSuccessMessage(returnFromApi.data);
          setShowSuccessMessage(true);
          cleanFields();
          getRegisteredMaterials();
          setLoading(false);
        })
        .catch((error) => {
          console.error('ops! ocorreu um erro' + error);
          setShowErrorMessage(true);
          setErrorMessage(error.response.data);
          setLoading(false);
        });
    }
  };

  const saveAdditive = (event) => {
    event.preventDefault();
    setLoading(true);

    if (isWaterReducingAdditive) {
      const waterReducingAdditive = {
        additiveId: materialId,
        name: name,
        specificMass: specificMass,
        saturationPercentage: saturationPercentage,
        supplierId: supplierToAdd,
        code: code,
        description: description,
        unitCost: unitCost
      };

      if (materialId) {
        api
          .put('/additive/water-reducing', waterReducingAdditive, {
            headers: {
              Authorization: sessionStorage.getItem('token')
            }
          })
          .then((returnFromApi) => {
            setSuccessMessage(returnFromApi.data);
            setShowSuccessMessage(true);
            cleanFields();
            getRegisteredMaterials();
            setLoading(false);
          })
          .catch((error) => {
            console.error('ops! ocorreu um erro' + error);
            setShowErrorMessage(true);
            setErrorMessage(error.response.data);
            setLoading(false);
          });
      } else {
        api
          .post('/additive/water-reducing', waterReducingAdditive, {
            headers: {
              Authorization: sessionStorage.getItem('token')
            }
          })
          .then((returnFromApi) => {
            setSuccessMessage(returnFromApi.data);
            setShowSuccessMessage(true);
            cleanFields();
            getRegisteredMaterials();
            setLoading(false);
          })
          .catch((error) => {
            console.error('ops! ocorreu um erro' + error);
            setShowErrorMessage(true);
            setErrorMessage(error.response.data);
            setLoading(false);
          });
      }
    } else {
      const additive = {
        additiveId: materialId,
        name: name,
        specificMass: specificMass,
        supplierId: supplierToAdd,
        code: code,
        description: description,
        unitCost: unitCost
      };

      if (materialId) {
        api
          .put('/additive', additive, {
            headers: {
              Authorization: sessionStorage.getItem('token')
            }
          })
          .then((returnFromApi) => {
            setSuccessMessage(returnFromApi.data);
            setShowSuccessMessage(true);
            cleanFields();
            getRegisteredMaterials();
            setLoading(false);
          })
          .catch((error) => {
            console.error('ops! ocorreu um erro' + error);
            setShowErrorMessage(true);
            setErrorMessage(error.response.data);
            setLoading(false);
          });
      } else {
        api
          .post('/additive', additive, {
            headers: {
              Authorization: sessionStorage.getItem('token')
            }
          })
          .then((returnFromApi) => {
            setSuccessMessage(returnFromApi.data);
            setShowSuccessMessage(true);
            cleanFields();
            getRegisteredMaterials();
            setLoading(false);
          })
          .catch((error) => {
            console.error('ops! ocorreu um erro' + error);
            setShowErrorMessage(true);
            setErrorMessage(error.response.data);
            setLoading(false);
          });
      }
    }
  };

  const saveWater = (event) => {
    event.preventDefault();
    setLoading(true);
    const water = {
      waterId: materialId,
      name: name,
      code: code,
      description: description,
      supplierId: supplierToAdd,
      specificMass: specificMass,
      unitCost: unitCost
    };

    if (materialId) {
      api
        .put('/water', water, {
          headers: {
            Authorization: sessionStorage.getItem('token')
          }
        })
        .then((returnFromApi) => {
          setSuccessMessage(returnFromApi.data);
          setShowSuccessMessage(true);
          cleanFields();
          getRegisteredMaterials();
          setLoading(false);
        })
        .catch((error) => {
          console.error('ops! ocorreu um erro' + error);
          setShowErrorMessage(true);
          setErrorMessage(error.response.data);
          setLoading(false);
        });
    } else {
      api
        .post('/water', water, {
          headers: {
            Authorization: sessionStorage.getItem('token')
          }
        })
        .then((returnFromApi) => {
          setSuccessMessage(returnFromApi.data);
          setShowSuccessMessage(true);
          cleanFields();
          getRegisteredMaterials();
          setLoading(false);
        })
        .catch((error) => {
          console.error('ops! ocorreu um erro' + error);
          setShowErrorMessage(true);
          setErrorMessage(error.response.data);
          setLoading(false);
        });
    }
  };

  const changeMaterialType = (materialType) => {
    setType(materialType);
  };

  function openModalToUpdate(material) {
    api
      .get('/materials/' + material.materialId, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        console.log(returnFromApi.data);
        setMaterialId(returnFromApi.data.materialId);
        setName(returnFromApi.data.name);
        setType(returnFromApi.data.type);
        setCode(returnFromApi.data.code);
        setDescription(returnFromApi.data.description);
        setSupplierId(returnFromApi.data.supplierId);
        setUnitMass(returnFromApi.data.unitMass);
        setSpecificMass(returnFromApi.data.specificMass);
        setSaturationPercentage(returnFromApi.data.saturationPercentage);
        setAggregateRetainedFractions(returnFromApi.data.aggregateRetainedFractions);
        setCementDiameterRetainedFractions(returnFromApi.data.cementRetainedFractions);
        setCValue(returnFromApi.data.cValue);
        setResistence(returnFromApi.data.resistence);
        setUnitCost(returnFromApi.data.unitCost)

        if (returnFromApi.data.type === 'ADDITIVE') {
          openModalToSaveAdditive('ADDITIVE');
        }
        if (returnFromApi.data.type === 'OTHERS_ADDITIVE') {
          openModalToSaveAdditive('OTHERS_ADDITIVE');
        }
        if (returnFromApi.data.type === 'WATER_REDUCING_ADDITIVE') {
          openModalToSaveAdditive('WATER_REDUCING_ADDITIVE');
        }
        if (returnFromApi.data.type === 'WATER') {
          openModalToSaveWater();
        }
        if (returnFromApi.data.type === 'GRAVEL') {
          openModalToSaveAggregates();
        }
        if (returnFromApi.data.type === 'SAND') {
          openModalToSaveAggregates();
        }
        if (returnFromApi.data.type === 'CEMENT') {
          openModalToSaveCement();
        }
      })
      .catch((error) => {
        console.error('ops! ocorreu um erro' + error);
        setShowErrorMessage(true);
        setErrorMessage(error.response.data);
      });
  }

  function deleteMaterial(material) {
    setLoading(true);
    api
      .delete('/materials/' + material.materialId, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setShowSuccessMessage(true);
        setSuccessMessage(returnFromApi.data);
        setLoading(false);
        getRegisteredMaterials();
      })
      .catch((error) => {
        console.error('ops! ocorreu um erro' + error);
        setShowErrorMessage(true);
        setErrorMessage(error.response.data);
        setLoading(false);
      });
  }

  const FractionRow = () => {
    return (
      <Row>
        <Form.Label className="fs-9"> Composição Granulométrica </Form.Label>
      </Row>
    );
  };

  return (
    <Card className="bg-transparent-50 overflow-hidden" style={{ minHeight: '250px' }}>
      <Authenticator />
      <Card.Header className="position-relative">
        <div className="row flex-between-center">
          {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
          {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}
          <div className="col col-lg-8">
            <h5 className="mb-0 texto-negrito">Materiais Cadastrados</h5>
          </div>

          <div className="col-12 col-sm-auto ms-auto">
            <Dropdown className="d-inline-block ms-2">
              <Dropdown.Toggle variant="falcon-default">Cadastrar Novo Material</Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} onClick={() => openModalToSaveAggregates()}>
                  Agregados
                </Dropdown.Item>
                <Dropdown.Item as={Link} onClick={() => openModalToSaveCement()}>
                  Cimento
                </Dropdown.Item>
                <Dropdown.Item as={Link} onClick={() => openModalToSaveAdditive('WATER_REDUCING_ADDITIVE')}>
                  Aditivo Redutor de Água
                </Dropdown.Item>
                <Dropdown.Item as={Link} onClick={() => openModalToSaveAdditive('OTHERS_ADDITIVE')}>
                  Outros Aditivos
                </Dropdown.Item>
                <Dropdown.Item as={Link} onClick={() => openModalToSaveWater()}>
                  Água
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <Loading isToHidden={isLoading == false} />

        <div hidden={isLoading}>
          <div className="text-center" hidden={registeredMaterials.length > 0}>
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">
              Nenhum material cadastrado ainda.
            </p>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="p-0" hidden={registeredMaterials.length == 0}>
        <Table responsive className={`form-container ${isLoading ? 'loading' : ''}`}>
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Código</th>
              <th scope="col">Fornecedor</th>
              <th scope="col">Observação</th>
              <th scope="col">Data de Criação</th>
              <th className="text-end" scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {registeredMaterials.map((material) => {
              return (
                <tr key={material.materialId}>
                  <td>{material.name}</td>
                  <td>{material.code}</td>
                  <td>{material.supplierName}</td>
                  <td>{material.description}</td>
                  <td>{material.formattedCreatedDate}</td>
                  <td className="text-end">
                    <Dropdown className="d-inline-block ms-2">
                      <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item as={Link} onClick={() => openModalToUpdate(material)}>
                          Editar
                        </Dropdown.Item>
                        <Dropdown.Divider as="div" />
                        <Dropdown.Item as={Link} onClick={() => deleteMaterial(material)} className="text-danger">
                          Excluir
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Card.Body>

      {/* AGGREGATES MODAL */}

      <Modal
        show={showModalToSaveAggregates}
        backdrop="static"
        keyboard={false}
        onHide={() => closeModalToSaveAggregates()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Agregados</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Loading isToHidden={isLoading == false} />
          {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
          {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}
          <Form onSubmit={saveAggregate} className={`mt-3 form-container ${isLoading ? 'loading' : ''}`}>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Nome</Form.Label>
                  <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Tipo</Form.Label>
                  <Form.Select value={type} onChange={(e) => setType(e.target.value)}>
                    <option value="">Selecione</option>
                    {materialsType.map((materialType) => (
                      <option key={materialType.type} value={materialType.type}>
                        {materialType.descriptionType}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Fornecedor</Form.Label>
                  <Form.Select value={supplierToAdd} onChange={(e) => setSupplierId(e.target.value)}>
                    <option value="">Selecione</option>
                    {suppliers.map((supplier) => {
                      return (
                        <option key={supplier.supplierId} value={supplier.supplierId}>
                          {supplier.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Código</Form.Label>
                  <Form.Control type="text" value={code} onChange={(e) => setCode(e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Massa Unitária Compactada (kg/m³)</Form.Label>
                  <Form.Control
                    type="text"
                    value={unitMass}
                    onChange={(e) => setUnitMass(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Massa Específica (kg/m³)</Form.Label>
                  <Form.Control
                    type="text"
                    value={specificMass}
                    onChange={(e) => setSpecificMass(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Custo unitário (reais/kg)</Form.Label>
                  <InputGroup className="mb-3">
                    <InputGroup.Text>R$</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={unitCost}
                      onChange={(e) => setUnitCost(sanitizeNumericInput(e.target.value))} />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Observação</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <FractionRow />
            <Row>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Peneira</Form.Label>
                  <Form.Select value={sieveToSave} onChange={(e) => setSieveToSave(e.target.value)}>
                    <option value="">Selecione</option>
                    {sieves.map((sieve) => {
                      return (
                        <option key={sieve.name} value={sieve.name}>
                          {sieve.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Porcentagem Retida (%)</Form.Label>
                  <Form.Control
                    type="text"
                    value={sieveValueToSave}
                    onChange={(e) => setSieveValueToSave(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Button className="mt-2 mt-md-4" onClick={() => addAggregateRetainedFraction()}>
                  Adicionar Fração
                </Button>
              </Col>
            </Row>
            <Row>
              <div className="text-center" hidden={aggregateRetainedFractions.length > 0}>
                <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">
                  Nenhuma fração cadastrada ainda.
                </p>
              </div>
              <Table responsive hidden={aggregateRetainedFractions.length === 0}>
                <thead>
                  <tr>
                    <th scope="col">Peneira</th>
                    <th scope="col">Porcentagem Retida</th>
                    <th className="text-end" scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {aggregateRetainedFractions.map((fraction) => {
                    console.log(fraction);
                    return (
                      <tr key={fraction.sieve}>
                        <td>{fraction.sieve}</td>
                        <td>{fraction.value}%</td>
                        <td className="text-end">
                          <Dropdown className="d-inline-block ms-2">
                            <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                as={Link}
                                onClick={() => deleteAggregateRetainedFraction(fraction)}
                                className="text-danger"
                              >
                                Excluir
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Row>
            <Button type="submit">Salvar</Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* CEMENT MODAL */}

      <Modal
        show={showModalToSaveCement}
        backdrop="static"
        keyboard={false}
        onHide={() => closeModalToSaveCement()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Cimento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Loading isToHidden={isLoading == false} />
          {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
          {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}
          <Form onSubmit={saveCement} className={`mt-3 form-container ${isLoading ? 'loading' : ''}`}>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Nome</Form.Label>
                  <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={8}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Fornecedor</Form.Label>
                  <Form.Select value={supplierToAdd} onChange={(e) => setSupplierId(e.target.value)}>
                    <option value="">Selecione</option>
                    {suppliers.map((supplier) => {
                      return (
                        <option key={supplier.supplierId} value={supplier.supplierId}>
                          {supplier.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Código</Form.Label>
                  <Form.Control type="text" value={code} onChange={(e) => setCode(e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Massa Específica (kg/m³)</Form.Label>
                  <Form.Control
                    type="text"
                    value={specificMass}
                    onChange={(e) => setSpecificMass(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Valor de C</Form.Label>
                  <Form.Control
                    type="text"
                    value={cValue}
                    onChange={(e) => setCValue(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Resistência (MPa)</Form.Label>
                  <Form.Control
                    type="text"
                    value={resistence}
                    onChange={(e) => setResistence(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Row>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Custo unitário (reais/kg)</Form.Label>
                    <InputGroup className="mb-3">
                      <InputGroup.Text>R$</InputGroup.Text>
                      <Form.Control
                        type="text"
                        value={unitCost}
                        onChange={(e) => setUnitCost(sanitizeNumericInput(e.target.value))} />
                    </InputGroup>
                  </Form.Group>
                </Col>

              </Row>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Observação</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <FractionRow />
            <Row>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Diâmetro</Form.Label>
                  <Form.Select
                    value={cementDiameterToSave}
                    onChange={(e) => setCementDiameterToSave(sanitizeNumericInput(e.target.value))}
                  >
                    <option value="">Selecione</option>
                    {diameters.map((diameter) => {
                      return (
                        <option key={diameter.name} value={diameter.name}>
                          {diameter.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Porcentagem (%)</Form.Label>
                  <Form.Control
                    type="text"
                    value={cementDiameterValueToSave}
                    onChange={(e) => setCementDiameterValueToSave(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Button className="mt-2 mt-md-4" onClick={() => addCementRetainedFraction()}>
                  Adicionar Fração
                </Button>
              </Col>
            </Row>
            <Row>
              <div className="text-center" hidden={cementDiameterRetainedFractions.length > 0}>
                <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">
                  Nenhuma fração cadastrada ainda.
                </p>
              </div>
              <Table responsive hidden={cementDiameterRetainedFractions.length === 0}>
                <thead>
                  <tr>
                    <th scope="col">Diâmetros</th>
                    <th scope="col">Porcentagem (%)</th>
                    <th className="text-end" scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  {cementDiameterRetainedFractions.map((fraction) => {
                    return (
                      <tr key={fraction.fraction}>
                        <td>{fraction.diameter}</td>
                        <td>{fraction.value}</td>
                        <td className="text-end">
                          <Dropdown className="d-inline-block ms-2">
                            <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                as={Link}
                                onClick={() => deleteCementRetainedFraction(fraction)}
                                className="text-danger"
                              >
                                Excluir
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Row>
            <Button type="submit">Salvar</Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ADDITIVE MODAL */}

      <Modal
        show={showModalToSaveAdditive}
        backdrop="static"
        keyboard={false}
        onHide={() => closeModalToSaveAdditive()}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Aditivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Loading isToHidden={isLoading == false} />
          {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
          {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}
          <Form onSubmit={saveAdditive} className={`mt-3 form-container ${isLoading ? 'loading' : ''}`}>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Nome</Form.Label>
                  <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Fornecedor</Form.Label>
                  <Form.Select value={supplierToAdd} onChange={(e) => setSupplierId(e.target.value)}>
                    <option value="">Selecione</option>
                    {suppliers.map((supplier) => {
                      return (
                        <option key={supplier.supplierId} value={supplier.supplierId}>
                          {supplier.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Massa Específica (kg/m³)</Form.Label>
                  <Form.Control
                    type="text"
                    value={specificMass}
                    onChange={(e) => setSpecificMass(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4} className={!isWaterReducingAdditive ? 'd-none' : ''}>
                <Form.Group className="mb-3" controlId="titleInput" isToHidden={true}>
                  <Form.Label className="fs-9">Percentual de Saturação (%)</Form.Label>
                  <Form.Control
                    type="text"
                    value={saturationPercentage}
                    onChange={(e) => setSaturationPercentage(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Código</Form.Label>
                  <Form.Control type="text" value={code} onChange={(e) => setCode(e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Custo unitário (reais/kg)</Form.Label>
                  <InputGroup className="mb-3">
                    <InputGroup.Text>R$</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={unitCost}
                      onChange={(e) => setUnitCost(sanitizeNumericInput(e.target.value))} />
                  </InputGroup>

                </Form.Group>
              </Col>

            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Observação</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button type="submit">Salvar</Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* WATER MODAL */}

      <Modal
        show={showModalToSaveWater}
        backdrop="static"
        keyboard={false}
        onHide={() => closeModalToSaveWater()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Água</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Loading isToHidden={isLoading == false} />
          {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
          {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}
          <Form onSubmit={saveWater} className={`mt-3 form-container ${isLoading ? 'loading' : ''}`}>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Nome</Form.Label>
                  <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Fornecedor</Form.Label>
                  <Form.Select value={supplierToAdd} onChange={(e) => setSupplierId(e.target.value)}>
                    <option value="">Selecione</option>
                    {suppliers.map((supplier) => {
                      return (
                        <option key={supplier.supplierId} value={supplier.supplierId}>
                          {supplier.name}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Código</Form.Label>
                  <Form.Control type="text" value={code} onChange={(e) => setCode(e.target.value)} />
                </Form.Group>
              </Col>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Massa Específica (kg/m³)</Form.Label>
                  <Form.Control
                    type="text"
                    value={specificMass}
                    onChange={(e) => setSpecificMass(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Custo unitário (reais/kg)</Form.Label>
                  <InputGroup className="mb-3">
                    <InputGroup.Text>R$</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={unitCost}
                      onChange={(e) => setUnitCost(sanitizeNumericInput(e.target.value))} />
                  </InputGroup>
                </Form.Group>
              </Col>

            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Observação</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button type="submit">Salvar</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Card>
  );
}
